var e={header:"FullScreenGalleryHeader-module_header__jqsds",title:"FullScreenGalleryHeader-module_title__0-NXl"};export{e as default};
//# sourceMappingURL=FullScreenGalleryHeader.module.scss.js.map
